// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"febc22e9","250":"09ab97c0","322":"f3149df5","454":"384d1c87","512":"8d1bee93","739":"cd0e40ba","875":"782b3b10","913":"e6e921d2"}[chunkId] + ".chunk.js";
};